<template>
  <div class="flex-col">
    <div class="w-full mt-2 panel">
      <div class="flex flex-row w-full text-blue font-bold">{{ $t('detailed_report_date') }}</div>
      <p class="text-gray-400 text-sm mb-2">{{ $t('detailed_report_date_help') }}</p>

      <div class="flex space-x-2">
        <div class="w-1/3">
          <b-field>
            <b-numberinput
              v-model="week"
              :placeholder="$t('week_of_the_year')"
              controls-position="compact"
              max="52"
              min="1"
              expanded
              icon-pack="fas"
              @keypress.native="onlyNumber"
            />
          </b-field>
          <!-- <input
          v-model="week" class="input"
          type="number" :placeholder="$t('week_of_the_year')"> -->
        </div>

        <div class="w-1/3">
          <b-datepicker
            :placeholder="$t('select_period')"
            v-model="weeklyRangeForm"
            :first-day-of-week="parseInt($t('first_day_of_week'))"
            :month-names="$t('months_names')"
            :day-names="$t('days_names')"
            icon-pack="fas"
            range
            >
          </b-datepicker>
        </div>
      </div>
    </div>

    <SelectSectionReportPanel v-if="report_sections.length > 1"
      :sections="report_sections"
      @epc-select-sections="(sections) => { report_sections = sections }"
    />

    <b-tabs v-if="report_sections.length" v-model="mainActiveTab" type="is-boxed">
      <!-- report sections -->
      <b-tab-item v-for="(tab, index) in report_sections" :key="'report_section_'+index" :visible="tab.print">

        <template slot="header">
          <b-icon pack="fas" icon="tasks"></b-icon>
          <span> {{ tab.name }} </span>
        </template>

        <div>
          <div class="w-full mt-4 panel">

            <div v-if="tab.progress_scheduled != undefined && tab.progress_scheduled != null" class="w-full mb-3">
              <div class="flex flex-row w-full text-blue font-bold">{{ $t('progress_scheduled_plant_photovoltaic') }}</div>
              <div class="flex flex-row w-3/3 border border-gray-300 rounded-lg p-2 bg-white shadow-md mt-3">
                <div v-for="progress in tab.progress_scheduled" class="w-2/5 my-2">
                  <div class="inline-block w-4/5">
                    <b-field :label="$t(progress.name)">
                      <b-input v-model="progress.value" type="is-primary"></b-input>
                    </b-field>
                  </div>
                </div>
              </div>
            </div>

            <!-- Enlace directo al Gantt -->
            <div v-if="tab.code === 'GANTT'" class="mb-3">
              <a href="/project/activities/gantt" target="_blank" class="button is-link is-outlined">
                <b-icon pack="fas" icon="external-link-alt"></b-icon>
                <span>{{ $t('open_gantt') }}</span>
              </a>
            </div>

            <div class="flex flex-row w-full text-blue font-bold">{{ $t('images') }}</div>
            <div class="w-full">

              <view-select-resource
                :visible="tab.with_drawing || tab.with_activity_document"
                :image="tab.with_drawing ? tab.drawing_image : tab.with_activity_document ? tab.activity_image : null"
                :type-resource="tab.with_drawing ? 'drawing' : 'activity'"
                :is-url="true"
                @epc-delete-resource="(type) => { deleteImage(tab.id, null, type) }"
                @epc-show-select-resource-modal="(type) => { openModalActivityImage(index, null, type) }"
              />

              <!-- Orientación del Gantt: solo si la config permite al usuario cambiarla.
                   Si no, se oculta y se usa la orientación definida en la config. -->
              <div v-if="tab.code === 'GANTT' && tab.gantt_user_can_change_orientation"
                class="flex justify-between items-center w-full mt-2 mb-2">
                <span class="mr-4">{{ $t('gantt_page_orientation') }}</span>
                <b-select v-model="tab.gantt_landscape" size="is-small">
                  <option :value="false">{{ $t('portrait') }}</option>
                  <option :value="true">{{ $t('landscape') }}</option>
                </b-select>
              </div>

              <!-- color picker and input text for status_oc name and color -->
              <!-- En la sección GANTT esta lista actúa como "leyenda general": se aplica
                   a todas las imágenes que no definan leyendas específicas propias. -->
              <legend-document-panel v-if="tab.with_status"
                :legends="tab.status_oc"
                :title="tab.code === 'GANTT' ? $t('general_legend') : null"
                :subtitle="tab.code === 'GANTT' ? $t('general_legend_hint') : null"
                @epc-add-legend="(legend) => { tab.status_oc.push(legend) }"
                @epc-delete-legend="(index) => { tab.status_oc.splice(index, 1) }"
              />

              <!-- image viewer from tab.images-->
              <div v-for="(image, imgindex) in tab.images" :key="'image_'+imgindex" class="w-full">
                <view-select-resource
                  :visible="tab.images.length > 0"
                  :image="image"
                  :type-resource="'image'"
                  :is-url="false"
                  :is-gantt="tab.code === 'GANTT'"
                  :named-resource="true"
                  :indexResource="imgindex + 1"
                  @epc-delete-resource="(type) => { deleteImage(tab.id, imgindex, type) }"
                  @epc-upload-resource="(type) => { uploadImage(tab.id, imgindex, tab.code == 'GANTT') }"
                  @epc-show-select-resource-modal="(type) => { openModalActivityImage(index, imgindex, type) }"
                  @epc-select-gantt-capture="(image) => { handleGanttCapture(tab.id, imgindex, image) }"
                />

                <!-- Leyendas específicas por imagen (solo Gantt con leyendas habilitadas):
                     apagado hereda la leyenda general; encendido usa solo su propia lista -->
                <div v-if="tab.code === 'GANTT' && tab.with_status && tab.images.length > 0"
                  class="w-full mt-1 mb-2"
                  style="margin-left: 1rem; padding-left: 1rem; border-left: 3px solid #dbdbdb;">
                  <div class="flex flex-row items-center">
                    <b-switch v-model="image.custom_legends" size="is-small" type="is-primary">
                      {{ $t('custom_legends_for_image', { number: imgindex + 1 }) }}
                    </b-switch>
                    <span v-if="!image.custom_legends" class="text-gray-400 text-sm ml-2">{{ $t('uses_general_legend') }}</span>
                  </div>
                  <legend-document-panel v-if="image.custom_legends"
                    :legends="image.legends"
                    :subtitle="$t('custom_legends_hint')"
                    @epc-add-legend="(legend) => { image.legends.push(legend) }"
                    @epc-delete-legend="(legendIndex) => { image.legends.splice(legendIndex, 1) }"
                  />
                </div>
              </div>

            </div>
          </div>
        </div>

      </b-tab-item>
    </b-tabs>

    <div class="w-full text-center">
      <b-button type="is-success" color="green" @click="exportReport" :loading="isLoadingExport" :tooltip="txtTooltipExport">
        <b-icon pack="fas" icon="file-export"></b-icon> <span>{{ $t('generate_report') }}</span>
      </b-button>
      <b-button type="is-primary" color="blue" @click="exportExcelCurrentProgress" :loading="isLoadingExportExcel" :tooltip="txtTooltipExport">
        <b-icon pack="fas" icon="file-export"></b-icon> <span>{{ $t('generate_only_excel') }}</span>
      </b-button>
    </div>

    <!-- modal with input image for upload Images (sin pie de foto en el clásico) -->
    <report-image-upload-modal ref="refUploadResourceModal"
      :show-caption="false"
      @load:image_section="handleLoadResource"
    />

    <select-image-from-activity-modal ref="refSelectResourceFromActivityModal"
      :activities="activities"
      :drawings="drawings"
      :report_sections="JSON.parse(JSON.stringify(report_sections))"
      @epc-select-success="handleSelectResourceFromActivity"/>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  import SelectSectionReportPanel from '../components/select-sections-report-panel.vue'
  import ViewSelectResource from '../components/view-select-resource.vue'
  import SelectImageFromActivityModal from '../components/select-image-from-activity-modal.vue'
  import ReportImageUploadModal from '../components/report-image-upload-modal.vue'
  import LegendDocumentPanel from '../components/legend-document-panel.vue'

  import {
    loadDetailedConfig,
    serializeSectionsForCache,
    mergeCacheIntoSections,
    applyLoadedReport,
    buildInfoTabs,
    storeImageVapor,
    formatWeeklyRange,
    isWeeklyRangeValid,
  } from '../services/detailed-report.service.js'
  import {
    fetchActivities,
    fetchSubactivities,
    fetchActivityDocuments,
    fetchProjectDrawings,
    generateDashboardReport,
    generateExcelCurrentProgress,
  } from '../api/index'
  import { onlyNumber as onlyNumberFn, mergeImageKeepingLegends } from '../helpers/detailed-report.helper.js'


  export default {
    components: {
      SelectSectionReportPanel,
      ViewSelectResource,
      SelectImageFromActivityModal,
      ReportImageUploadModal,
      LegendDocumentPanel
    },

    props: {
      typeReport: { type: String, default: null },
    },

    data: () => ({
      s3bucket: window.config.s3bucket,
      isLoading: true,

      weeklyRangeForm: [],
      weeklyRange: [], // rango de fechas procesado
      week: null, // semana enviado para el pdf

      status_oc:[], // { name: 'status name', color: 'color',}

      report_sections: [],

      showModal: false,
      UploadId: null,
      uploadImageIdx: null,
      dropFileTemp: null,
      uploadImageName: null,

      mainActiveTab: 0,

      isLoadingExport: false,
      isLoadingExportExcel: false,
      txtTooltipExport: null,
      activities: [],
      drawings: [],
      showModalActivityImage: false,
      showModalDrawingImage: false,
      activityImage: {
        tabIndex: 0,
        imageIndex: 0,
        url: '',
        activity_id: null,
        subactivity_id: null,
        document_id: null,
        subactivities: [],
        documents: [],
        type: 'image'
      },
    }),

    computed: {
      selectedCompanyAlias: function() {
        return this.company ? this.company.alias : null
      },
      ...mapGetters({
        project: 'app/project',
        user: 'auth/user',
        company: 'app/company',
        dashboardReport: 'app/dashboardReport',
      }),
    },

    created() {
      this.loadConfigDetailedReport()
    },

    mounted() {
      if (this.project == null) {
        this.$router.push('/projects');
      } else {

        let pageInfo = {
          title: this.$t('report_generation'),
          subtitle: this.$t('report_generation_subtitle'),
          menuOption: '2-1',
        }

        this.$store.dispatch('app/updatePageInfo', {info: pageInfo})

        this.getActivities()
        this.getDrawings()
      }

    },

    methods: {
      // Delega en el helper puro (la plantilla llama a este método en @keypress).
      onlyNumber (event) {
        return onlyNumberFn(event)
      },

      handleSelectResourceFromActivity(obj) {
        this.report_sections = obj;
      },

      handleLoadResource(resource) {
        const images = this.report_sections.find(tab => tab.id == resource.tabId).images
        images.splice(resource.loadImageIdx, 1, mergeImageKeepingLegends(images[resource.loadImageIdx], resource.image))
        this.$refs.refUploadResourceModal.hide();
      },

      async getSubactivities(activityId){
        const data = await fetchSubactivities(activityId);
        return data.subactivities;
      },

      async getActivities(){
        const data = await fetchActivities(this.project.id);
        this.activities = data.activities;
      },

      async getDocuments(activityId){
        const data = await fetchActivityDocuments(activityId);
        return data.documents.filter(doc => doc.type == 1 || (doc.type == 0 && doc.mime_type == 'application/pdf'));
      },

      async getDrawings(){
        const data = await fetchProjectDrawings(this.project.id);
        if (data && data.success) {
          this.drawings = data.documents;
        }
      },

      // MODAL ACTIVITY DOCUMENTS FUNCTIONS
      async openModalActivityImage(tabIndex, imageIndex, type = 'image', modal = 'activity') {
        this.activityImage = {
          tabIndex,
          imageIndex,
          url: '',
          activity_id: null,
          subactivity_id: null,
          document_id: null,
          subactivities: [],
          documents: [],
          type
        }

        // if (modal == 'drawing') {
        //   console.log('openModalActivityImage', this.activityImage);
        //   this.showModalDrawingImage = true
        // } else {
          // this.showModalActivityImage = true
          this.$refs.refSelectResourceFromActivityModal.show(this.activityImage);
        // }
      },

      uploadImage(tabId, imgIndex, isGantt = false) {
        this.$refs.refUploadResourceModal.show({tabId, imgIndex, isGantt});
      },

      handleGanttCapture(tabId, imgIndex, image) {
        const images = this.report_sections.find(tab => tab.id == tabId).images
        images.splice(imgIndex, 1, mergeImageKeepingLegends(images[imgIndex], image));
      },

      deleteImage(tabId, imageIndex, type = 'image') {
        if (type == 'drawing') {
          this.report_sections.find(tab => tab.id == tabId).drawing_image = '';
        } else if (type == 'activity') {
          this.report_sections.find(tab => tab.id == tabId).activity_image = '';
        } else {
          const images = this.report_sections.find(tab => tab.id == tabId).images
          images.splice(imageIndex, 1, mergeImageKeepingLegends(images[imageIndex], {id: imageIndex + 1, name: this.$t('image_number', { number: imageIndex + 1 }), image: null}))
        }
      },

      async exportExcelCurrentProgress(){
        if (this.isLoadingExportExcel) return
        this.txtTooltipExport = this.$t('generating');
        this.$notify.success('generating_report');
        this.isLoadingExportExcel = true;
        try {
          await generateExcelCurrentProgress(this.project.id)
          this.$notify.success('generating_report')
        } catch (error) {
          this.$notify.error(error.error_msg || 'error_retrieving_data')
        } finally {
          this.isLoadingExportExcel = false
          this.txtTooltipExport = this.$t('export')
        }
      },

      async exportReport() {
        if (this.isLoadingExport) return

        // El rango de semana es obligatorio: define el corte de fecha del informe.
        // Si no está seleccionado, avisamos y abortamos (evita el error en backend).
        if (!isWeeklyRangeValid(this.weeklyRangeForm)) {
          this.$buefy.toast.open({
            message: this.$t('select_week_range_required'),
            type: 'is-warning',
            position: 'is-top-right',
          });
          return;
        }

        this.txtTooltipExport = this.$t('generating');

        // guardamos configuración
        await this.saveConfigToCache()

        this.weeklyRange = formatWeeklyRange(this.weeklyRangeForm)

        this.$notify.success('generating_report');
        this.isLoadingExport = true;
        try {
          // El armado de infoTabs (y la subida de imágenes por Vapor) vive en el servicio.
          const infoTabs = await buildInfoTabs(
            this.report_sections,
            (file, opts) => this.storeImage(file, opts),
            window.config.s3bucket
          )
          await generateDashboardReport(this.project.id, { infoTabs, weeklyRange: this.weeklyRange, week: this.week })
          this.$notify.success('generating_report')
          this.$emit('refresh-history')
        } catch (error) {
          this.$notify.error(error.error_msg || 'error_retrieving_data')
        } finally {
          this.isLoadingExport = false
          this.txtTooltipExport = this.$t('export')
        }
      },

      // Sube una imagen por Vapor (lógica en el servicio); aquí solo inyectamos el callback
      // de progreso que actualiza el estado de la vista (uploadPercentage).
      async storeImage(file, options = null) {
        const opts = options || {}
        return storeImageVapor(file, {
          bucket: opts.bucket,
          contentType: opts.contentType,
          expires: opts.expires,
          onProgress: (pct) => { this.uploadPercentage = pct },
        })
      },

      async saveConfigToCache() {
        const config = serializeSectionsForCache(this.report_sections)
        this.$store.dispatch('app/setDashboardReport', {dashboardReport: { report_sections: config} })
      },

      async loadConfigFromCache() {
        mergeCacheIntoSections(this.report_sections, this.dashboardReport.report_sections)
      },

      async loadConfigDetailedReport() {
        let cfg = []
        try {
          cfg = await loadDetailedConfig(this.project)
        } catch (e) {
          this.$buefy.toast.open({ message: this.$t('error_loading_data'), type: 'is-danger' })
        }
        this.report_sections = cfg
        this.loadConfigFromCache()
      },

      LoadReport(report) {
        // Aplica el informe guardado a las secciones (ramas por disciplina) en el servicio;
        // aquí solo asignamos semana y rango de fechas devueltos.
        const { week, weeklyRangeForm } = applyLoadedReport(this.report_sections, report)
        this.week = week
        this.weeklyRangeForm = weeklyRangeForm
      },

    },

  };
</script>
